import { useParams } from "react-router-dom";
import axios from "../api/axiosClient";
import { useState, useEffect, useRef } from "react";
import { Card, Typography, Button, Grid } from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { Box } from "@mui/system";
import CustomTable from "../components/ui/CustomTable";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import { toast } from "react-hot-toast";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { handleError, errorToast, useKeyDown } from "../services/serviceBase";
import { useLoading } from "../components/LoadingContext";
import { useNavigate } from "react-router-dom";
import ReturnFileHeader from "../components/ui/ReturnFileHeader";
import ReturnFileActions from "../components/ui/ReturnFileActions";
import RADetailsThresholdMessage from "../components/ui/CreditNote/RADetailsThresholdMessage";
import { setDoSearch } from "../redux/searchSlice";
import useStreamState from "../components/CustomHooks/useStreamState";

const RADetails = () => {
  const intl = useIntl();
  const { setLoading } = useLoading();
  const params = useParams();
  const { idReturnFileHead } = params;
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [details, setDetails] = useState([]);
  const [render, setRender] = useState(false);
  const [detailsHeader, setDetailsHeader] = useState(null);
  const [detailsColumns, setDetailsColumns] = useState([]); 
  const [detailsRows, setDetailsRows] = useState([]);
  const [groupedDetailsRows, setGroupedDetailsRows] = useState([]);
  const [outcomes, setOutcomes] = useState([]);
  const [showGrouped, setShowGrouped] = useState(false);
  const [isExtraRFHead, setIsExtraRFHead] = useState(false);
  const [showRADetailsThresholdMessage, setShowRADetailsThresholdMessage] = useState(false);
  const [postQCInfo, setPostQCInfo] = useState(false);
  const [state, setState] = useState(null);

  const withStealthFlow = useSelector((state) => state.common.withStealthFlow);

  const [tableHeigth, setTableHeigth] = useState(600);
  const resizeTable = () => {
    var headerHeight = document.querySelector("#header")?.clientHeight;
    var actionsHeight = document.querySelector("#actions")?.clientHeight;
    var raDetailsThresholdMessageHeigth = document.querySelector("#RADetailsThresholdMessage")?.clientHeight ?? 0;
    var pageHeight = window.innerHeight;
    var tableHeight = pageHeight - headerHeight - actionsHeight - raDetailsThresholdMessageHeigth - 110;
    setTableHeigth(tableHeight);
  };

  useKeyDown(() => {
    handleBarcodeFilterInputChange();
  }, ["Enter"]);

  const [searchItem, setSearchItem] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);

  useEffect(() => {
    window.addEventListener("resize", resizeTable);
    return () => {
      window.removeEventListener("resize", resizeTable);
    };
  }, []);

  useEffect(() => {
    getDetailsHeaderColumns();
  }, [detailsRows, groupedDetailsRows]);

  const getDetailsHeaderColumns = () => {
    setDetailsColumns([
      {
        field: "barcode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Sku" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        renderCell: (params) => {
          return <div>{params.row.barcode + params.row.checkDigit}</div>;
        },
        flex: 1,
        minWidth: 120,
      },
      {
        field: "styleCode",
        headerClassName: "grid-header apeLigthBlueBackground ",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Model" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        flex: 1,
        minWidth: 80,
      },
      {
        field: "fabricCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Part" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        flex: 1,
        minWidth: 80,
      },
      {
        field: "colorCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Color" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        flex: 1,
        minWidth: 80,
      },
      {
        field: "dropCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Drop" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        flex: 1,
        minWidth: 80,
      },
      {
        field: "size",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Size" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        flex: 1,
        minWidth: 80,
      },
      {
        field: "articleDescription",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Description" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        flex: 1,
        minWidth: 400,
      },
      {
        field: "renderedQty",
        headerClassName: "grid-header apeLigthBlueBackground ",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Peces" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        flex: 1,
        minWidth: 80,
      },
    ]);
  };

  useEffect(() => {
    getDetails();
  }, []);

  function groupByStyleFabricColorArray(data) {
    const groupMap = new Map();
    
    data.forEach(item => {
      const key = `${item.styleCode}-${item.fabricCode}-${item.colorCode}`;
      
      if (!groupMap.has(key)) {
        groupMap.set(key, {
          styleCode: item.styleCode,
          fabricCode: item.fabricCode,
          colorCode: item.colorCode,
          skuDescription: item.skuDescription,
          items: []
        });
      }
      
      groupMap.get(key).items.push(item);
    });
    
    return Array.from(groupMap.values());
  }

  useEffect(() => {
    resizeTable();
    console.log(showRADetailsThresholdMessage);
  }, [showRADetailsThresholdMessage])

  const getDetails = () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + idReturnFileHead)
      .then((response) => {
        setLoading(false);
        setDetails(response.data);
        setDetailsHeader(response.data.returnFileHeadInfo);
        var groupedDetailsByStyleFabricColor = groupByStyleFabricColorArray(response.data.returnFileRowInfoList);
        if(groupedDetailsByStyleFabricColor.length > 999){
          setShowRADetailsThresholdMessage(true);
        }

        setState({
          rfState: response.data.returnFileHeadInfo.rfState,
          rfStateCode: response.data.returnFileHeadInfo.rfStateCode,
        });

        if (response.data.outcomes != [] && response.data.outcomes.length > 0) {
          var groupedItems = [];
          var filteredUDMs = [];
          var rowsData = response.data.returnFileRowInfoList;
          if (
            searchItem != null &&
            searchItem != undefined &&
            searchItem != ""
          ) {
            if (
              filteredRows.length != 0 &&
              filteredRows.length < response.data.returnFileRowInfoList.length
            ) {
              filteredRows.forEach((d) => {
                filteredUDMs.push(d);
              });
              let allData = response.data.returnFileRowInfoList;
              let filteredData = filteredUDMs;

              let filteredBoxBarcode = filteredData.map((x) => {
                return x.boxBarcode;
              });
              let finalData = allData.filter((x) =>
                filteredBoxBarcode.includes(x.boxBarcode)
              );

              rowsData = finalData;
            } else if (filteredRows.length == 0) {
              rowsData = [];
            }
          }

          rowsData.forEach((detail) => {
            const { idAnagQCOutcome, boxBarcode, isExtra } = detail;
            var currentGroupOfOutcome = groupedItems.find(
              (x) => x.idAnagQCOutcome == idAnagQCOutcome
            );
            if (
              currentGroupOfOutcome === undefined ||
              currentGroupOfOutcome === null
            ) {
              groupedItems.push({
                idAnagQCOutcome: idAnagQCOutcome,
                boxes: [
                  {
                    boxBarcode: boxBarcode,
                    isExtra: detail.isExtra,
                    items: [detail],
                  },
                ],
              });
            } else {
              var currentGroupOfBox = currentGroupOfOutcome.boxes.find(
                (x) => x.boxBarcode == boxBarcode
              );
              if (
                currentGroupOfBox === undefined ||
                currentGroupOfBox === null
              ) {
                currentGroupOfOutcome.boxes.push({
                  boxBarcode: boxBarcode,
                  isExtra: detail.isExtra,
                  items: [detail],
                });
              } else {
                var currentGroupItem = currentGroupOfBox.items.find(
                  (x) => x.barcode === detail.barcode
                );
                if (
                  currentGroupItem === undefined ||
                  currentGroupItem === null
                ) {
                  currentGroupOfBox.items.push(detail);
                } else {
                  currentGroupItem.renderedQty += detail.renderedQty;
                }
              }
            }
          }, {});

          setOutcomes(response.data.outcomes);
          setGroupedDetailsRows(groupedItems);

          let isRFExtra = groupedItems.map((x) => x.boxes.map((x) => x.isExtra)).every(x=>x);
          setIsExtraRFHead(isRFExtra);

          setDetailsRows(rowsData);
          setShowGrouped(true);
        } else {
          let groupedByBarcodeDetails = [];
          response.data.returnFileRowInfoList.map((detail) => {
            var currentGroup = groupedByBarcodeDetails.find(
              (x) => x.barcode === detail.barcode
            );
            if (currentGroup === undefined || currentGroup === null) {
              groupedByBarcodeDetails.push(detail);
            } else {
              let qty = currentGroup.renderedQty;
              qty += detail.renderedQty;
              currentGroup.renderedQty = qty;
            }
          });
          setDetailsRows(groupedByBarcodeDetails);
        }

        setRender(true);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, () => {
          errorToast(error, intl);
        });
      });
  };

  const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  }));

  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary {...props} />
  ))(({ theme }) => ({
    border: `1px solid white`,
  }));

  const handleBarcodeFilterInputChange = (filterBarcodeValue) => {
    var currentDetails =
      details.returnFileRowInfoList == undefined
        ? details
        : details.returnFileRowInfoList;

    const searchTerm = filterBarcodeValue;
    setSearchItem(searchTerm);
    const filteredItems = currentDetails.filter((detail) =>
      detail.barcodeAndCheckDigit.includes(searchTerm)
    );

    setFilteredRows(filteredItems);
  };

  useEffect(() => {
    getDetails();
  }, [filteredRows]);

  const setIsUrgent = (isUrgent) => {
    setDetailsHeader({ ...detailsHeader, isUrgent: isUrgent });
  }

  useEffect(() => {
    const fetchState = async () => {
      const response = await fetch(
        process.env.REACT_APP_BASE_URL +
          "returnfiles/" +
          idReturnFileHead +
          "/streamPostQCInfo",
        {
          headers: {
            Accept: "text/event-stream",
            Authorization: `Bearer ${user.access_token}`,
          },
        }
      );

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value);
        const lines = chunk.split("\n");
        for (const line of lines) {
          if (line.startsWith("data: ")) {
            const data = line.slice(6);
            if (data.trim()) {
              try {
                const parsed = JSON.parse(data);
                if (parsed) {
                  setPostQCInfo(true);
                }
              } catch (e) {
                console.error("Errore parsing JSON:", e);
              }
            }
          }
        }
      }
    };

    fetchState().catch((error) => {
      handleError(error, intl);
    });
  }, []);

  useStreamState({ detailsHeader, idReturnFileHead, user, setState, intl });

  const handleBack = () => {
    navigate(`${process.env.PUBLIC_URL}/RASearch`);
  };

  return (
    <Box>
      {render ? (
        <Box>
          <ReturnFileHeader
            idRFHeadRelated={detailsHeader.idRFHeadRelated}
            idReconditionType={detailsHeader.idReconditionType}
            returnFileKey={detailsHeader.returnFileKey}
            rfDate={detailsHeader.rfDate}
            rfType={detailsHeader.rfDepartmentDescr}
            //rfState={detailsHeader.rfState}
            rfState={state?.rfState}
            reconditionTypeDescr={detailsHeader.reconditionTypeDescr}
            ictReference={detailsHeader.ictReference}
            invoiceNumber={detailsHeader.invoiceNumber}
            saprso={detailsHeader.saprso}
            sapInboundDelivery={detailsHeader.sapInboundDelivery}
            totalPieces={detailsHeader.totalPieces}
            idReturnFileHead={idReturnFileHead}
            callBackAftereChangeReconditionType={getDetails}
          />

          <ReturnFileActions
            idReturnFileHead={idReturnFileHead}
            handleBarcodeFilterInputChange={handleBarcodeFilterInputChange}
            showSKUSearch={true}
            detailsHeader={detailsHeader}
            setIsUrgent={setIsUrgent}
            rfState={detailsHeader.rfStateCode}
            rfType={detailsHeader.rfTypeCode}
            isRFExtra={isExtraRFHead}
            withStealthFlow={withStealthFlow}
            enableBoxQCButton={postQCInfo}
            returnFileKey={detailsHeader.returnFileKey}
          />
          {showRADetailsThresholdMessage ? (
            <Box sx={{ mt: 1 }}>
              <RADetailsThresholdMessage />
            </Box>
          ) : (
            ""
          )}
          <Card sx={{ mt: 1, height: `${tableHeigth}px`, overflow: "auto" }}>
            {showGrouped ? (
              groupedDetailsRows.map((outcome) => {
                var currentOutcome = outcomes.find(
                  (x) => x.idAnagQCOutcome === outcome.idAnagQCOutcome
                );
                return (
                  <Accordion
                    key={`${outcome.idAnagQCOutcome}`}
                    defaultExpanded={true}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      className="apeRaDetailOutcomeBackground"
                    >
                      <Typography variant="subtitle1" sx={{ ml: 1 }}>
                        {intl.formatMessage({ id: "General.Outcome" })}:{" "}
                        <strong>
                          {currentOutcome?.buttonLabel !=
                          currentOutcome?.outcomeDescription
                            ? currentOutcome?.buttonLabel
                            : currentOutcome?.outcomeDescription}
                        </strong>
                      </Typography>
                    </AccordionSummary>
                    {outcome.boxes.map((box) => {
                      var sum = 0;
                      for (let i = 0; i < box.items.length; i++) {
                        sum += box.items[i].renderedQty;
                      }

                      var height = 25 + 75 * box.items.length;
                      return (
                        <Accordion
                          key={`${box.boxBarcode}`}
                          defaultExpanded={true}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            className={
                              box.isExtra
                                ? "apeRaDetailsBoxBackgroundExtraQty"
                                : "apeRaDetailsBoxBackground"
                            } //cambia questa classe
                          >
                            <Typography variant="subtitle1" sx={{ ml: 1 }}>
                              {intl.formatMessage({ id: "General.BoxBarcode" })}
                              : <strong>{box.boxBarcode}</strong> -{" "}
                              {intl.formatMessage({ id: "General.Peces" })}:{" "}
                              <strong>{sum}</strong>
                            </Typography>
                          </AccordionSummary>
                          <CustomTable
                            key={`${box.boxBarcode}${outcome.idAnagQCOutcome}`}
                            columns={detailsColumns}
                            rows={box.items}
                            id={"rowNumber"}
                            rowHeight={40}
                            headerHeight={30}
                            tableHeight={height}
                          />
                        </Accordion>
                      );
                    })}
                  </Accordion>
                );
              })
            ) : (
              <CustomTable
                columns={detailsColumns}
                rows={detailsRows}
                id={"rowNumber"}
                rowHeight={40}
                headerHeight={30}
                tableHeight={tableHeigth}
              />
            )}
          </Card>
        </Box>
      ) : (
        <div>Loading...</div>
      )}
      <Grid container mt={2}>
        <Grid item lg={2}>
          <Button
            variant="outlined"
            className="apeBlueColor"
            fullWidth
            onClick={handleBack}
          >
            {intl.formatMessage({ id: "QC.Back" })}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RADetails;
